import type { RouteRecordRaw } from 'vue-router'

const portfolioRoutes: RouteRecordRaw[] = [
  {
    path: 'portfolio',
    component: () => import('@/views/portfolio/PortfolioLayout.vue'),
    redirect: '/portfolio/alignments',
    children: [
      {
        path: 'alignments',
        name: 'portfolio-alignments',
        component: () => import('@/views/portfolio/AlignmentList.vue')
      },
      {
        path: 'alignments/:id',
        name: 'portfolio-alignment-detail',
        component: () => import('@/views/portfolio/AlignmentDetail.vue')
      }
    ]
  }
]

export default portfolioRoutes
